import { render } from "./DataDeletionContent.vue?vue&type=template&id=6e983cd8&scoped=true"
import script from "./DataDeletionContent.vue?vue&type=script&lang=js"
export * from "./DataDeletionContent.vue?vue&type=script&lang=js"

import "./DataDeletionContent.vue?vue&type=style&index=0&id=6e983cd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e983cd8"]])

export default __exports__